import { writable } from 'svelte/store';
import ComponentHome from '../pages/Home.svelte';
import ComponentPageActus from '../pages/Actus.svelte';
import ComponentPageDecouvrir from '../pages/Decouvrir.svelte';
import ComponentPageAccompagner from '../pages/Accompagner.svelte';
import ComponentPageContacts from '../pages/Contacts.svelte';
import ComponentPageMentionsLegales from '../pages/MentionsLegales.svelte';
import ComponentPageActu from '../pages/Actu.svelte';
import ComponentPageProjets from '../pages/Projets.svelte';
import ComponentPageCharte from '../pages/Charte.svelte';
import ComponentPageBudget2025 from '../pages/Budget2025.svelte';
import { idPageHome, idPageDecouvrir, idPageAccompagner, idPageActualites, idPageContacts, idPageMentionsLegales, idPageActu, idPageProjets, idPageCharte, idPageBudget2025, namePageHome, namePageDecouvrir, namePageAccompagner, namePageActualites, namePageContacts, namePageMentionsLegales, namePageActu, namePageProjets, namePageCharte, namePageBudget2025 } from "./router2";
export const storeCurRoute = writable(idPageHome);
export const routes = [];
export const pageHome = { id: idPageHome, name: namePageHome, anchor: '', component: ComponentHome };
routes.push(pageHome);
export const pageDecouvrir = { id: idPageDecouvrir, name: namePageDecouvrir, anchor: '', component: ComponentPageDecouvrir };
routes.push(pageDecouvrir);
export const pageAccompagner = { id: idPageAccompagner, name: namePageAccompagner, anchor: '', component: ComponentPageAccompagner };
routes.push(pageAccompagner);
export const pageActualites = { id: idPageActualites, name: namePageActualites, anchor: '', component: ComponentPageActus };
routes.push(pageActualites);
export const pageContacts = { id: idPageContacts, name: namePageContacts, anchor: idPageContacts, component: ComponentPageContacts };
routes.push(pageContacts);
export const pageMentionsLegales = { id: idPageMentionsLegales, name: namePageMentionsLegales, anchor: '', component: ComponentPageMentionsLegales };
routes.push(pageMentionsLegales);
export const pageActu = { id: idPageActu, name: namePageActu, anchor: '', component: ComponentPageActu };
routes.push(pageActu);
export const pageProjets = { id: idPageProjets, name: namePageProjets, anchor: '', component: ComponentPageProjets };
routes.push(pageProjets);
export const pageCharte = { id: idPageCharte, name: namePageCharte, anchor: '', component: ComponentPageCharte };
routes.push(pageCharte);
export const pageBudget2025 = { id: idPageBudget2025, name: namePageBudget2025, anchor: '', component: ComponentPageBudget2025 };
routes.push(pageBudget2025);
/**
 * redirectTo
 *
 * @param path
 */
export function redirectTo(idPage, params = "") {
    storeCurRoute.set(idPage);
    // push the path into web browser history API
    window.history.pushState({ path: "#" + idPage }, '', window.location.origin + "/" + idPage + params);
}
/**
 * historyNavigation
 * Écoute de l’événement popstate qui est lancé lorsque l’historique change.
 * Le clic sur le back du navigateur est écouté et la route courante actualisée
 *
 * @param event
 */
export function historyNavigation(event) {
    // change current router path
    if (event.state.path.indexOf("#") >= 0 && storeCurRoute != undefined) {
        storeCurRoute.set(event.state.path.replace('#', ''));
    }
}
